<div 
    class="modal fade show" 
    [ngClass]="{'expanded': isExpanded}"
    id="config-modal" 
    tabindex="-1" 
    aria-labelledby="config-modalLabel" 
    aria-hidden="true"
    [ngStyle]="{'display': 'block'}"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <div class="d-flex w-100">
                    <div class="me-2 id">
                        <h4 class="modal-title mb-0 item-id">Technicians</h4>
                    </div>
                    <div class="btns-header ms-auto">
                        <button 
                            class="header-icon close p-0 m-0" 
                            (click)="close()" 
                            aria-label="Close"
                        >
                            <i 
                                class="fas fa-times" 
                                title="Close Popup"
                            ></i>
                        </button>
                        <button 
                            class="close header-icon expand-modal p-0 m-0"
                            (click)="isExpanded = !isExpanded"
                        >
                            <i 
                                class="fas ms-2 me-2" 
                                [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}" 
                                [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"
                            ></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body pt-3">
                <div class="row">
                    <div class="col">
                        @if (gridConfig) {
                        <div [style.height.px]="gridHeight">
                            <inavista-grid #resourceGrid class="so-popup-grid"
                                [config]="gridConfig"
                                [actionIcons]="actionIcons"
                                (actionIconClick)="onActionIconClick($event)" />
                        </div>
                        }
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-danger close-modal" (click)="close()">Close</button>
                <!-- <button type="button" class="btn btn-sm btn-success" [disabled]="!selectedRowData" (click)="proceed()">Proceed</button> -->
            </div>
        </div>
    </div>
</div>